import { render, staticRenderFns } from "./purchasePlan.vue?vue&type=template&id=6ce22709&"
import script from "./purchasePlan.vue?vue&type=script&lang=js&"
export * from "./purchasePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports